module.exports = __webpack_public_path__ + "img/startup.fc7f3cdd.svg";